import { Component, Input } from '@angular/core';
import { IBlockUserRequest } from '../../../classes/block-user';
import { FormGroup } from '@nbg-globals/form-controls';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'lock-user-complete',
	template: require('./lock-user-complete.component.html'),
})
export class LockUserCompleteComponent {
	@Input() controls: FormGroup<IBlockUserRequest>;
	public isRebrading = AppSettings.isRebrading;
	phone = '+30 210 77 27 44 0';

	constructor() {}
}
